import React from 'react';
import { Input } from '../../ui';

interface WaitInputConfigProps {
  config: any;
  onChange: (key: string, value: any) => void;
}

export const WaitInputConfig: React.FC<WaitInputConfigProps> = ({ config, onChange }) => {
  const groupingEnabled = config.messageGroupingEnabled === true;

  return (
    <div className="space-y-4">
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 text-xs text-blue-700 leading-relaxed">
        <strong>Como funciona:</strong> Pausa o fluxo e aguarda o usuário digitar uma resposta livre (texto, número, e-mail, etc.). A resposta é salva na variável definida abaixo e pode ser usada nos próximos nós com <code className="bg-blue-100 px-1 rounded">{'{{nome_variavel}}'}</code>. No modo <strong>Conversa livre</strong>, esse valor permanece salvo na mesma conversa (sessão) nas próximas execuções até ser alterado ou a sessão ser reiniciada.
      </div>
      <Input
        label="Nome da Variável"
        placeholder="Ex: nome_cliente"
        value={config.variableName || ''}
        onChange={(e) => onChange('variableName', e.target.value.replace(/\s/g, '_'))}
        helperText="A resposta será salva nesta variável"
      />
      <div>
        <label className="block text-sm font-medium text-slate-700 mb-1">
          Mensagem de Prompt
        </label>
        <textarea
          className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          rows={2}
          placeholder="Ex: Por favor, digite seu nome"
          value={config.prompt || ''}
          onChange={(e) => onChange('prompt', e.target.value)}
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-slate-700 mb-1">
          Validação
        </label>
        <select
          className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={config.validationType || 'none'}
          onChange={(e) => onChange('validationType', e.target.value)}
        >
          <option value="none">Nenhuma</option>
          <option value="email">E-mail</option>
          <option value="phone">Telefone</option>
          <option value="number">Número</option>
          <option value="cpf">CPF</option>
          <option value="regex">Regex personalizado</option>
        </select>
      </div>

      <div className="rounded-lg border border-slate-200 p-3">
        <label className="flex items-center gap-2 text-sm font-medium text-slate-700">
          <input
            type="checkbox"
            checked={groupingEnabled}
            onChange={(e) => onChange('messageGroupingEnabled', e.target.checked)}
          />
          Agrupar mensagens neste bloco
        </label>
        <p className="mt-1 text-xs text-slate-500">
          Quando ativo, o bot aguarda alguns segundos e junta mensagens antes de validar.
        </p>

        <div className="mt-2 flex items-center gap-2">
          <span className="text-xs text-slate-600">Janela</span>
          <input
            type="number"
            min={1}
            max={120}
            value={Number.isFinite(Number(config.messageGroupingWindowSeconds)) ? Number(config.messageGroupingWindowSeconds) : 5}
            onChange={(e) => onChange('messageGroupingWindowSeconds', Math.max(1, Math.min(120, Number(e.target.value) || 5)))}
            disabled={!groupingEnabled}
            className="w-24 rounded-md border border-slate-300 px-2 py-1 text-sm disabled:opacity-50"
          />
          <span className="text-xs text-slate-600">segundos</span>
        </div>
      </div>
    </div>
  );
};
